export default {
  state: {
    val: {
      message: "",
      result: {}
    }
  },
  getters: {
    getVal: state => state.val
  },
  actions: {
    setVal({ commit }, args) {
      commit("INFO_MSG", args);
    },
    resetVal({ commit }) {
      commit("INFO_MSG", { message: "", result: {} });
    }
  },
  mutations: {
    INFO_MSG: (state, payload) => {
      state.val = payload;
    }
  },
  namespaced: true
};
